<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="uppercase font-jost-medium text-blue-dark text-base">{{ getAssetTitle(asset) }}</h2>
    <div class="flex items-center justify-between gap-4">
      <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0 flex-wrap lg:flex-nowrap">
        <div class="flex items-center min-w-0 flex-2">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Asset:</span>
          <router-link
            class="text-[#374151] font-jost-regular text-base break-all hover:underline"
            :title="getAssetValue(asset)"
            :to="{ name: 'nft', params: { chainNumber: asset.chainNumber || $route.params.chainNumber || $route.params.chain, nftId: getAssetValue(asset) } }">
            {{ getAssetValue(asset) }}
          </router-link>
        </div>

        <!-- <div v-if="asset.chainName" class="flex items-center gap-2 text-base flex-1 min-w-0">
          <span class="text-[#6B7280]">Chain Name:</span>
          <span class="text-[#374151] font-jost-regular" :title="asset.chainName">
            {{ asset.chainName }}
          </span>
        </div>

        <div v-if="getIssuer(asset)" class="flex items-center min-w-0 flex-1">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Issuer:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="getIssuer(asset)">
            {{ truncateAddress(getIssuer(asset)) }}
          </span>
        </div> -->
      </div>

      <!-- <div v-if="hasAssetMeta(asset)" class="flex items-center gap-4 text-base flex-wrap justify-end">
        <div v-if="asset.symbol" class="text-right">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Symbol:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="asset.symbol">
            {{ asset.symbol }}
          </span>
        </div>
        <div v-if="asset.totalSupply" class="text-right">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Total supply:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="asset.totalSupply">
            {{ asset.totalSupply }}
          </span>
        </div>
        <div v-if="asset.decimalPlaces !== undefined && asset.decimalPlaces !== null" class="text-right">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Decimals:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="String(asset.decimalPlaces)">
            {{ asset.decimalPlaces }}
          </span>
        </div>
      </div> -->
    </div>
  </li>
</template>

<script>
import { truncateAddress } from '@/helpers/common';

export default {
  name: 'AssetCard',
  props: {
    asset: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    truncateAddress(address) {
      return truncateAddress(address);
    },
    getAssetTitle(asset) {
      return asset?.chainName ? `${asset.chainName} Asset` : 'Asset';
    },
    getAssetValue(asset) {
      return asset?.assetHash || asset?.hash || asset?.value || asset?.tokenName || asset?.symbol || 'N/A';
    },
    getIssuer(asset) {
      return asset?.creator || asset?.issuer || asset?.owner || '';
    },
    hasAssetMeta(asset) {
      return Boolean(
        asset?.symbol || asset?.totalSupply || asset?.decimalPlaces !== undefined && asset?.decimalPlaces !== null
      );
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
